import { ObservableLevelsEnum } from '../../data/enums';
import {
  EquipmentPartModel,
  InspectionCategoryTypeModel,
} from '../../data/types';
import { tocUndercarriageScreenPathValues } from '../../pages/inspections/undercarriage/tocUndercarriageScreenPath';
import { observationService } from '../observationService';

class RollerAssemblyService {
  static shared = new RollerAssemblyService();
  constructor() {}

  static getRollerAssemblyCompletePercentage(
    partName: string,
    categoryTypes: InspectionCategoryTypeModel[],
    equipmentPart?: EquipmentPartModel,
  ): number {
    if (equipmentPart === undefined) {
      return -1;
    }

    const pathObjects = tocUndercarriageScreenPathValues.find(
      (element) =>
        element.partName === partName &&
        element.level === ObservableLevelsEnum.equipmentPart,
    );

    const anyPath = observationService.entityObservationsHasAnyPaths({
      elements: categoryTypes,
      requiredPaths: pathObjects?.anyPaths ?? [],
      pathsStartingWith: pathObjects?.anyPathStartsWith ?? [],
      level: ObservableLevelsEnum.equipmentPart,
      entityId: equipmentPart.id,
      entityExternalId: equipmentPart.externalId,
    });

    return anyPath ? 100 : -1;
  }

  static getRollerAssembliesCompletePercentage(
    categoryTypes: InspectionCategoryTypeModel[],
    partName: string,
    equipmentParts: EquipmentPartModel[],
  ) {
    const pathObjects = tocUndercarriageScreenPathValues.find(
      (element) =>
        element.partName === partName &&
        element.level === ObservableLevelsEnum.equipmentPart,
    );

    const anyPaths = equipmentParts.map((equipmentPart) =>
      observationService.entityObservationsHasAnyPaths({
        elements: categoryTypes,
        requiredPaths: pathObjects?.anyPaths ?? [],
        pathsStartingWith: pathObjects?.anyPathStartsWith ?? [],
        level: ObservableLevelsEnum.equipmentPart,
        entityId: equipmentPart.id,
        entityExternalId: equipmentPart.externalId,
      }),
    );
    if (anyPaths.every((element) => element == true)) {
      return 100;
    }

    if (anyPaths.every((element) => element == false)) {
      return -1;
    }

    return 0;
  }
}

export default RollerAssemblyService;
